module.exports = __webpack_public_path__ + "Main Logo Green and Yellow.png?7ed9990c2aeb430785b95a196032aeb3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/Main Logo Green and Yellow.png
// module id = 25
// module chunks = 0